module.exports = __webpack_public_path__ + "img/P150T_weapon_136.9a3a6d7b.png";